<template>
  <div class="slider-navigation" :class="[theme]">
    <div v-if="dots && !isMobileView" class="slider-dots">
      <div
        class="dot"
        v-for="n in (stories.length + 2)"
        :class="{active: (n - 2) === dotActive, prev: (n - 2) < dotActive, opened: n > 1 && n <= (stories.length + 1) && openedDot === (n - 2)}"
        :key="n"
        @mouseover="openedDot = n - 2"
        @mouseleave="openedDot = false"
        @click="changeStory(n - 2)"
      >
        <div v-if="n > 1 && n <= stories.length + 1" class="dot-hover">
          <div class="img" :style="{ backgroundImage: `url(${stories[n - 2].image})` }" alt />
          <span class="text">{{ stories[n - 2].title | dotdotdot(20) }}</span>
        </div>
      </div>
    </div>
    <div v-if="arrows" class="slider-arrows">
      <span
        class="arrow arrow-prev"
        :class="{hover: leftArrowHovered}"
        @click="prevSlide"
        @mouseover="handleArrowHover('left', true)"
        @mouseleave="handleArrowHover('left', false)"
      >
        <div class="arrow-hover"></div>
        <div class="arrow-icon"></div>
      </span>
      <span
        v-if="currentStoryIndex < stories.length"
        class="arrow arrow-next"
        :class="{hover: rightArrowHovered}"
        @click="nextSlide"
        @mouseover="handleArrowHover('right', true)"
        @mouseleave="handleArrowHover('right', false)"
      >
        <div class="arrow-hover"></div>
        <div class="arrow-icon"></div>
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      dots: true,
      arrows: true,
      openedDot: false,
      leftArrowHovered: false,
      rightArrowHovered: false,
    };
  },
  props: {
    theme: String,
  },
  computed: {
    ...mapState([
      "stories",
      "currentStoryIndex",
      "dotActive",
      "windowWidth",
      "isMobileDevice",
    ]),
    ...mapGetters(["isMobileView"]),
  },
  methods: {
    ...mapActions(["changeStory", "changePage"]),
    nextSlide() {
      if (this.currentStoryIndex >= this.stories.length) return;
      this.changeStory(this.currentStoryIndex + 1);
    },
    prevSlide() {
      if (this.currentStoryIndex <= -1) {
        this.changePage(1);
        return;
      }
      this.changeStory(this.currentStoryIndex - 1);
    },
    handleArrowHover(arrow, hover) {
      if (this.isMobileDevice) return;
      if (arrow === "left") {
        this.leftArrowHovered = hover;
      } else {
        this.rightArrowHovered = hover;
      }
    },
  },
};
</script>

<style lang="scss">
.slider-navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 72px;
  width: calc(100% - 4vw);
  margin-left: 2vw;
  padding: 16px 0;
  z-index: 30;
  .slider-dots {
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 36;
    max-width: 80vw;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      width: 100%;
      height: 0;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
    }
    .dot {
      position: relative;
      display: block;
      width: 8px;
      height: 8px;
      background-color: #fff;
      border-radius: 50%;
      .dot-hover {
        position: absolute;
        width: 110px;
        left: 50%;
        transform: translateX(-50%);
        top: -30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        opacity: 0;
        transition: all 0.3s;
        pointer-events: none;
        .img {
          display: block;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.11);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        .text {
          font-size: 14px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          line-height: 18px;
          text-shadow: 0px 2px 4px rgba(0,0,0,0.4);
        }
      }
      &.opened {
        .dot-hover {
          opacity: 1;
          top: -130px;
          pointer-events: all;
        }
        &:after {
          content: "";
          width: 0;
          height: 20px;
          position: absolute;
          bottom: 25px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 1px dashed rgba(255, 255, 255, 0.4);
        }
      }
      &.prev {
        background-color: #bbb;
      }
      &:hover {
        cursor: pointer;
      }
      &.active,
      &:hover {
        &:before {
          opacity: 1;
        }
      }
      &:before {
        content: "";
        position: absolute;
        width: 26px;
        height: 26px;
        border: 1px solid #fff;
        border-radius: 50%;
        left: -10px;
        top: -10px;
        opacity: 0;
        transition: 0.3s;
      }
    }
  }
  .slider-arrows {
    position: absolute;
    width: 100%;
    height: 35px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 35;
    .arrow {
      position: absolute;
      display: block;
      width: 20px;
      height: 100%;
      .arrow-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url("~@/assets/img/arrow.svg");
        background-repeat: no-repeat;
        background-size: cover;
      }
      .arrow-hover {
        position: absolute;
        width: 0;
        height: 0;
        top: 40px;
        left: 40px;
        border-radius: 50%;
        border: 145px solid #dd2211;
        z-index: -1;
        transition: 0.3s;
      }
      &.arrow-prev {
        left: 0;
        transform: rotate(180deg);
        .arrow-hover {
          bottom: 40px;
          right: 40px;
          top: auto;
        }
        &.hover {
          .arrow-hover {
            bottom: -70px;
            right: -85px;
            top: auto;
          }
        }
      }
      &.arrow-next {
        right: 0;
      }
      &.hover {
        cursor: pointer;
        .arrow-hover {
          top: -70px;
          left: -85px;
        }
      }
    }
  }
  &.blue {
    .slider-dots {
      .dot {
        background-color: #0055bb;
        .dot-hover {
          .text {
            color: #0055bb;
          }
        }
        &.opened {
          &:after {
            border-left: 1px dashed rgba(0, 85, 187, 0.64);
          }
        }
        &.prev {
          background-color: rgba(0, 85, 187, 0.64);
        }
        &:before {
          border: 1px solid #0055bb;
        }
      }
      &:before {
        border-bottom: 1px dashed rgba(0, 85, 187, 0.64);
      }
    }
    .slider-arrows {
      .arrow {
        .arrow-icon {
          background-image: url("~@/assets/img/arrow_b.svg");
        }
        &.hover {
          .arrow-icon {
            background-image: url("~@/assets/img/arrow.svg");
          }
        }
      }
    }
  }
}
</style>